;(function ($) {
    $(document).ready(function () {
        //show menu
        $('.btn-menu').click(function (e) {
            e.preventDefault();
            var $html = $('html');
            // $(this).toggleClass('active');
            $html.toggleClass('js-overflow');
            $('.js-menu').toggleClass('active');
            $('.btn-search').fadeToggle(0);
        });

        //show search
        $('.btn-search, .close-form-search').click(function (e) {
            e.preventDefault();
            $('.container-form-search').fadeToggle();
        });


        var $multipleItems = $('.multiple-items');
        $multipleItems.on('swipe', function(event, slick, direction){
            if (direction === 'left') $('.section-slider .multiple-items .slick-list').addClass('js-margin');
            // left
        });
        //init slider
        $multipleItems.slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: false,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        arrows: false,
                        centerMode: true,
                        autoplay: false,
                        centerPadding: '50px'
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });

        //our work detail
        var $singleItem = $('.single-item');
        $singleItem.slick({
            infinite: false,
            responsive: [
                {
                    breakpoint: 420,
                    settings: {
                        arrows: false,
                    }
                }
            ]
        });

        $singleItem.on('swipe', function(event, slick, direction){
            if (direction === 'left') $('.section-slider-single .single-item .slick-list').css('margin', '0 auto');
            // left
        });

        $('.single-item .slick-next').one('click', function () {
            $('.single-item .slick-prev, .single-item .slick-next').addClass('active');
            $('.single-item .slick-list').css('margin', '0 auto');
        })

        //show tab home page
        $('.head-tab').click(function (e) {
            e.preventDefault();
            var self = $(this);
            var id = self.find('a').attr('href');
            self.addClass('active').siblings().removeClass('active');
            $(id).addClass('active').siblings().removeClass('active');
        });

        //iframe run video
        $('.section-video .play-btn').click(function (e) {
            e.preventDefault();
            $('.iframe-wrapper').css('display', 'block');
            $('#sidebar_video')[0].src += "&autoplay=1";
        });

        $('a.stop-video, .iframe-wrapper').click(function(e){
            e.preventDefault();
            $('#sidebar_video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
            $('#sidebar_video')[0].contentWindow.postMessage('{"method":"pause"}', '*');
            $('.iframe-wrapper').css('display', 'none');
        });

        //filter show
        $('.aside-filter-button').click(function (e) {
            e.preventDefault();
            $('.alm-filters').slideToggle();
        });

        //show team
        var $blockTeam = $('.container-team .block-team');
        var $containerTeam = $('.container-team');
        var $showTeam = $('.show-team');
        var $showTeamHidden = $('.show-team.hidden');

        if($(window).outerWidth() >= 767 && $(window).outerWidth() < 991){
            showTeam(7);
        }else if($(window).outerWidth() <= 991){
            showTeam(4);
        }else{
            $blockTeam.fadeIn(0);
        }

        $(window).resize(function () {

            if($(window).outerWidth() >= 767 && $(window).outerWidth() < 991){
                if ($showTeamHidden.length !== 0)
                showTeam(7);
            }else if($(window).outerWidth() <= 991){
                if ($showTeamHidden.length !== 0)
                showTeam(4);
            }else{
                $blockTeam.fadeIn(0);
            }
        });

        $showTeam.click(function (e) {
            e.preventDefault();
            $blockTeam.fadeIn(300);
            $containerTeam.css('height','100%');
            $(this).addClass('hidden').removeClass('show');
        });

        function showTeam(iteration) {

            $blockTeam.each(function (i, el) {
                if(i <= iteration){
                    $(el).fadeIn(0);
                }else{
                    $(el).fadeOut(0);
                }
            });
        }

        //scroll top
        $('body').on('click', '.paginate a', function(e){
            var linkTarget = $('#main');
            $('html, body').animate({scrollTop:linkTarget.position().top}, 1000);

        });


        //accardion
        var containerAcсоrdion = $('.tablet>ul>li.menu-item-has-children');
        if(containerAcсоrdion.length > 0){
            containerAcсоrdion.prepend('<a href="" class="js-active"></a>');
            $('.tablet').on('click', '.js-active', function (e) {
                e.preventDefault();
                $(this).toggleClass('rotate');
                $(this).parent().find('a + .sub-menu').toggleClass('active');

            });
        }

        //open accordion
        // console.log($('.current-page-ancestor').length > 0);

        var elementMenu = $('.current-page-ancestor');
        if(elementMenu.length > 0){
            elementMenu.find('.js-active').addClass('rotate');
            elementMenu.find('a+.sub-menu').addClass('active');
        }

        //readability tabs
        var tabElement = $('.group-title a');
        tabElement.click(function (e){
            e.preventDefault();
            var self = $(this);
            var id = self.attr('href');
            // console.log(self);
            if(!self.hasClass('active')) {
                $('#content_result').html('');
                $('#site_url').val('').attr('placeholder', 'https://');
                $('#site_text').val('').attr('placeholder', 'Text');
            }

            tabElement.removeClass('active');
            self.addClass('active');
            // console.log(id);
            $('.group-field li').removeClass('active');
            $('.group-field '+ id).addClass('active');
        });

        //cookie gate form
        var $contentupgrade_1 = $('#contentupgrade_1');

        if($contentupgrade_1.length > 0 && $('div[data-contentupgradeid="1538"]').length > 0){
            $('div[data-contentupgradeid="1538"]').on('click','input[type="submit"]', function (){
                $contentupgrade_1.on("DOMNodeInserted", function () {
                    if ($('.contentupgrade-postform-content').length > 0){
                        $('.contentupgrade-postform-content').css('display', 'none');
                        window.location.reload();
                    }
                });
            })
        }
        else if($contentupgrade_1.length > 0 && $('.tool-template-quiz-page').length > 0){
            $contentupgrade_1.on('click','input[type="submit"]', function (){
                $contentupgrade_1.on("DOMNodeInserted", function () {
                    if ($('.contentupgrade-postform-content').length > 0){
                        $('.contentupgrade-postform-content').css('display', 'none');
                        window.location.reload();
                    }
                });
            })
        }


        function detectMob() {
            const toMatch = [
                /Android/i,
                /webOS/i,
                /iPhone/i,
                /iPad/i,
                /iPod/i,
                /BlackBerry/i,
                /Windows Phone/i
            ];

            return toMatch.some((toMatchItem) => {
                return navigator.userAgent.match(toMatchItem);
            });
        }

        if (detectMob())$('body').addClass('mobile-version');

        //widget button target to form
        //scroll to form
        $('#target-form').click(function (e){
            e.preventDefault();
            var linkTarget = $('.section-form');
            $('html, body').animate({scrollTop:linkTarget.position().top}, 1000);
        });

        if ($('.section-form').length > 0 && !detectMob() && $(window).width() > 974){
            //sticky widget
            var topWidgetHeight = '';
            var topWidgetPosition = '';

            function watchSticky(){
                // if (widgetHtmlPosition  > topWidgetPosition + topWidgetHeight + 20){
                    widgetHtmlPosition = topWidgetPosition + topWidgetHeight + 20;
                // }

                if ( window.scrollY >= widgetHtmlPosition - marginTop  && window.scrollY + widgetHtmlHeight + marginBottom < sectionFormPosition ){
                    widgetHtml.attr('style','');
                    widgetHtml.css({
                        'position': 'fixed',
                        'top': marginTop + 'px',
                        'z-index': 1,
                        'width': widgetHtmlWidth + 'px'

                    });
                }else if (window.scrollY + widgetHtmlHeight + marginBottom >= sectionFormPosition ){
                    widgetHtml.attr('style','');
                    widgetHtml.css({
                        'position': 'absolute',
                        'bottom': '0px',
                        'z-index': 1,
                        'width': widgetHtmlWidth + 'px'

                    });
                } else if (window.scrollY < widgetHtmlPosition - marginTop){
                    widgetHtml.attr('style','');
                    widgetHtml.css({
                        'position': 'static',
                        'top': '0px'

                    });
                }

            }

            function outputSizeWidget() {
                var topWidget = $('#smartcta_nfprofiling_widget-14, #smartcta_nfprofiling_widget-12');

                if (topWidget.length > 0){
                    topWidgetHeight = topWidget.outerHeight();
                    topWidgetPosition = topWidget.offset().top;
                }

                widgetHtmlPosition = widgetHtml.offset().top;
                // widgetHtmlWidth = widgetHtml.width();
                widgetHtmlHeight = widgetHtml.height();

            }

            function outputSizeBody() {
                sectionFormPosition = $('.section-form').position().top;
            }

            var widgetHtml = $('#widget-html').parent();
            var widgetHtmlPosition = widgetHtml.offset().top;
            var widgetHtmlWidth = widgetHtml.width();
            var widgetHtmlHeight = widgetHtml.height();

            var sectionFormPosition = $('.section-form').position().top;
            widgetHtml.parent().height(widgetHtmlHeight).css('margin-bottom','20px');

            var marginTop = 100;
            var marginBottom = 175;

            new ResizeObserver(outputSizeWidget).observe($('.sidebar-location-sidebar-insights-details').get(0));
            new ResizeObserver(outputSizeBody).observe($('body').get(0));
            new ResizeObserver(watchSticky).observe($('.sidebar-location-sidebar-insights-details').get(0), $('body').get(0));

            watchSticky();
            $(window).scroll(function (){
                watchSticky()
            });
        }
    });
})(jQuery);
